import {
  Box,
  Button,
  Card,
  FormControl,
  Input,
  InputLabel,
  Typography,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { FC } from 'react';

export const AdminCard: FC = () => {
  const { handleSubmit, control } = useForm();
  const onSubmit = (data: any) =>
    (window.location.href = `/workday/dev?userid=${data.userid}`);

  const enterKeyValue = 13;
  const handleKeyPress = (key: any, value: string) => {
    if (key.charCode === enterKeyValue) {
      var data: { [userid: string]: any } = {};
      data.userid = value;
      onSubmit(data);
    }
  };

  return (
    <Card>
      <Box px={2} py={1}>
        <Typography variant="h5">Admin</Typography>
        <Box>
          <FormControl>
            <Controller
              name={'userid'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <>
                  <InputLabel htmlFor="userid">
                    Anställningsnummer
                  </InputLabel>
                  <Input
                    id="userid"
                    onChange={onChange}
                    value={value}
                    onKeyPress={(e) => {
                      handleKeyPress(e, value);
                    }}
                  />
                </>
              )}
            />
            <Box py={1}>
              <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                Logga in
              </Button>
            </Box>
          </FormControl>
        </Box>
      </Box>
    </Card>
  );
};
